<template>
  <GeoVerification
    :action-label="t(useTranslationPath(callerPath, 'continue'))"
    :verification-method="useGetConfigVar('ENGINEER_APP_CHECK_IN_METHOD')"
    :is-loading
    @continue="handleCheckIn"
    @access-code="handleAccessCode"
  />
</template>

<script setup>
import GeoVerification from '@/components/Verification/GeoVerification.vue'
import { useGetConfigVar } from '@/composables/useGetConfigVar.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { isLocationEnabled } from '@/composables/useVerificationMethod.js'
import { useAppStore } from '@/stores/AppStore.js'
import { useEngineerStore } from '@/stores/authenticated/EngineerStore.js'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()

const router = useRouter()

const appStore = useAppStore()
const engineerStore = useEngineerStore()

const callerPath = 'views.authenticated.verification.geo'

const isLoading = ref(false)

onMounted(() => {
  appStore.$patch({ showBackButton: false })
  engineerStore.$patch({
    verificationData: {
      checkIn: { method: null, data: null },
      checkOut: { method: null, data: null },
    },
  })
})

const handleCheckIn = async (verified = true, coordinates = null) => {
  isLoading.value = true

  if (isLocationEnabled('ENGINEER_APP_CHECK_IN_METHOD') && verified) {
    engineerStore.$patch({
      verificationData: {
        checkIn: {
          method: 'GEOLOCATION',
          data: { lat: coordinates[0], lng: coordinates[1] },
        },
        checkOut: {
          method: null,
          data: null,
        },
      },
    })
  }

  await router.push({ name: 'work-order.index' })
}

const handleAccessCode = async () => {
  isLoading.value = true

  await router.push({
    name: 'verification.code',
  })
}
</script>
